/*
 * constants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here.
 */

export const TEAM_FETCH_INIT = "ModuleInitials/TEAM_FETCH_INIT";
export const TEAM_FETCH_SUCCESS = "ModuleInitials/TEAM_FETCH_SUCCESS";
export const TEAM_EXCEPTION_WHILE_FETCH = "ModuleInitials/TEAM_EXCEPTION_WHILE_FETCH";
export const TEAM_SELECT = "ModuleInitials/TEAM_SELECT";
export const TEAM_UPDATE_INIT = "ModuleInitials/TEAM_UPDATE_INIT";
export const TEAM_UPDATE_SUCCESS = "ModuleInitials/TEAM_UPDATE_SUCCESS";
export const TEAM_EXCEPTION_WHILE_UPDATE = "ModuleInitials/TEAM_EXCEPTION_WHILE_UPDATE";
export const LOGOUT_CLEAR_TEAM = "ModuleInitials/LOGOUT_CLEAR_TEAM";
